export default {
  index: {
    text1: "Mời mời",
    text2: "Tài sản",
    text3: "Hóa đơn",
    text4: "Khu vực đặc biệt",
    text5: "Quy ước 1 sao",
    text6: "Đăng ký",
    text7: "Quy ước 2 sao",
    text8: "Giới thiệu",
    text9: "Tham gia cộng đồng của chúng tôi",
    text10: "Liên kết tài khoản cao cấp",
    text11: "Vui lòng nhập địa chỉ người giới thiệu",
    text12: "Xác nhận",
    text13: "Tài khoản Khuyến mãi",
    text14: "Phần còn lại của phần thưởng",
    text15: "Chờ mở",
	text16: "Đối tác hợp tác",
  },
  wallet: {
    text1: "Tổng giá trị tài sản",
    text2: "Hóa đơn",
    text3: "Số dư",
    text4: "Rút ra",
    text5: "Lợi ích danh sách trắng",
    text6: "Lợi ích IDO",
    text7: "Đăng ký",
    text8: "兑换",
  
  },
  dui :{
  	text1: "兑换白名单权益",
  
  },
  pawn: {
    text1: "Lợi nhuận sẽ được thanh toán vào 18:18 ngày hôm sau. 70% lợi nhuận hàng ngày sẽ được thanh toán bằng USDT và 30% bằng代币 UES tương đương. Giá trị thị trường UES là 3U.",
    text2: "Đăng ký",
    text3: "cái",
    text4: "Quy ước 1 sao",
    text5: "Lợi nhuận hàng ngày",
    text6: "Quy ước 2 sao",
    text7: "Quy ước 3 sao",
    text8: "Quy ước Plus"
  },
  zy: {
    text1: "Trong quá trình kiếm lợi nhuận",
    text2: "Hết hạn",
    text3: "Số lượng",
    text5: "Đã kiếm được",
    text4: "Ngày đăng ký"
  },
  team: {
    text1: "Cấp độ hiện tại",
    text2: "Đăng ký của tôi",
    text3: "Thành tích chung cư",
    text4: "Người giới thiệu của tôi",
    text5: "Đăng ký của người giới thiệu",
    text6: "Đội của tôi",
    text7: "Tổng cộng Hiệu suất",
    text8: "Thành tích chung cư",
    text9: "Đội ngũ",
    text10: "Giới thiệu của tôi",
    text11: "Số lượng đăng ký",
    text12: "Liên kết mời"
  },
  withdrawal: {
    text1: "Số lượng rút ra",
    text2: "Đến账",
    text3: "Phí dịch vụ",
    text4: "Số dư ví",
    text5: "Rút ra và đóng băng",
    text6: "Xác nhận",
    text7: "Vui lòng nhập số lượng rút ra"
  },
  record: {
    text1: "Loại",
    text2: "Số lượng",
    text3: "Thời gian"
  },
  header: {
    text1: 'Thêm',
    text2: "Liên kết giới thiệu",
    text3: "Trang chủ",
    text4: "Ví",
    text5: "Đăng ký",
    text6: "Quy ước của tôi",
    text7: "Đội của tôi",
	text8: 'RLP白名单',
  },
  lan: {
    text1: 'Tiếng Anh',
    text2: 'Trung Quốc giản thể',
    text3: 'Trung Quốc phức tạp',
    text4: 'Tiếng Thái',
    text5: 'Tiếng Hàn',
    text6: 'Tiếng Nhật',
    text7: 'Tiếng Việt'
  },
  tost: {
    text1: 'Chờ mở',
    text2: 'Vui lòng nhập số lượng tiền điện tử muốn rút',
    text3: 'Số dư không đủ',
    text4: 'Sao chép thành công',
	text5: 'Chuyển ra ít nhất 50 USDT',
  },
  rlp: {
  	 text10: "Đăng ký mua RLP",
  	    text1: "100 hạn mức trong danh sách trắng có thể đăng ký mua 0.1BNB",
  	    text2: "Đăng ký mua",
  	    text4: "Định giá đăng ký mua",
  	    text3: "100 hạn mức / 0.1BNB",
  	    text5: "BNB",
  	    text6: "Danh sách trắng của tôi",
  	    text7: "Đăng ký mua"
  	
  },
  aitoken: {
    brand: 'GMI Cloud',
    connectWallet: 'Kết nối ví',
    language: 'Ngôn ngữ',
    tabs: {
      home: 'Trang chủ',
      business: 'Dịch vụ',
      orders: 'Đơn hàng',
      referral: 'Giới thiệu',
    },
  },
}
